export const FAVICON_URL =
  'https://zmyle.libpx.com/eu-west-1/static/zmyle-icon-sq.png';

export enum ZmyleErrorId {
  INTERNAL_SERVER_ERROR = 'api:ex:internalError',
  TOO_MANY_REQUESTS = 'api:biz:tooManyRequests',
  NO_SUCH_GIFTCARD = 'api:biz:noSuchGiftcard',
  NO_SUCH_NETWORK = 'api:biz:noSuchNetwork',
  INVALID_QR_CODE = 'api:io:invalidQrCode',
  REQUIRES_AUTHENTICATION = 'api:biz:requiresAuthentication',
  MALFORMED_ID = 'api:io:malformedId',
  MALFORMED_URL = 'api:io:malformedUrl',
  INVALID_PINCODE = 'api:biz:invalidPincode',
  NO_SUCH_GIFTCARD_CONTEXT = 'api:biz:noSuchGiftcardCheckoutContext',
  IDEMPOTENT_REQUEST_BUSY = 'api:biz:idempotentRequestBusy',
  NO_SUCH_GIFTCARD_DEPOT = 'api:biz:noSuchGiftcardDepot',
  PDF_SERVICE_ERROR = 'api:biz:pdfServiceError',
}

// site-wide crawler directives; previously authored in the Prismic `default` SEO document
export const DEFAULT_ROBOTS =
  'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1';

export const NOINDEX_ROBOTS = 'noindex, nofollow'; // non-indexable surfaces

// site-wide search vocabulary, held in code for the same reason as DEFAULT_ROBOTS;
// every term appears in the site's own published German copy
export const GLOBAL_KEYWORDS = [
  'Gutschein',
  'Gutscheine',
  'Online-Gutscheine',
  'Stadtgutschein',
  'Stadtgutscheine',
  'Regionalgutschein',
  'Gutscheinlösungen',
  'zmyle',
  'zmyle GmbH',
];
